import React from 'react';
import { reduxForm, Field } from 'redux-form';

import FormError from 'components/FormError';
import InputField from 'components/InputField';
import CheckboxField from 'components/CheckboxField';
import { isBlank } from 'helpers/validators';

import styles from './styles.module.scss';

let MassChargeForm = ({ handleSubmit, error }) => {
  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <div className={styles.inputs}>
        <Field
          component={InputField}
          name="purchase_ids"
          label="Purchase IDs*"
          subText="Comma separated list. Ex.: 1,2,3"
        />
        <Field
          component={InputField}
          name="emails"
          label="Emails*"
          subText="Comma separated list. Ex.: email@test.test,email@test.com"
        />
      </div>
      <div className={styles.checkboxes}>
        <Field
          component={CheckboxField}
          name="only_with_autopay"
          label="Only with autopay"
        />
        <Field
          component={CheckboxField}
          name="enable_autopay"
          label="Enable autopay"
        />
        <Field
          component={CheckboxField}
          name="only_overdue"
          label="Only overdue"
        />
        <Field
          component={CheckboxField}
          name="run_all_cards_on_file"
          label="Run all cards on file"
        />
      </div>
      {error && <FormError error={error} />}
      <br />
      <button className="btn btn-primary">Mass Charge</button>
    </form>
  );
};

const validate = (values) => {
  let errors = {};

  const requiredFields = ['purchase_ids', 'emails'];
  requiredFields.forEach((field) => {
    if (isBlank(values[field])) {
      errors[field] = 'Required';
    }
  });

  return errors;
};

MassChargeForm = reduxForm({
  form: 'massChargeForm',
  validate,
})(MassChargeForm);

export default MassChargeForm;
